import { useCallback, useEffect, useState } from "react";
import {
  getCustomerFtth,
  getProjectFtth,
  reportCustomerActivations,
  reportFtthCustomers,
  reportFtthProjects,
} from "../../api/customer";

export function useFtthGroupListHooks() {
  const [projects, setProjects] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getProjects = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getProjectFtth({ ...filter });
      setProjects(data.data.projects);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getProjects();
  }, []);

  return {
    projects,
    loading,
    errorMsg,
    getProjects,
  };
}

export function useReportFtthProject({ filter }) {
  const [projects, setProjects] = useState([]);
  const [meta, setMeta] = useState({ total: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getProjects = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await reportFtthProjects(filter);
      setProjects(data.data);
      setMeta(data.meta);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getProjects(filter);
  }, [filter]);

  return {
    projects,
    meta,
    loading,
    errorMsg,
    getProjects,
  };
}

export function useReportCustomerFtth({ filter }) {
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getCustomers = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await reportFtthCustomers(filter);
      setCustomers(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getCustomers(filter);
  }, [filter]);

  return {
    customers,
    meta,
    loading,
    errorMsg,
    getCustomers,
  };
}

export function useCustomerFtth({ id, filter }) {
  const [data, setData] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getCustomer = useCallback(
    async (currentFilter = {}) => {
      setLoading(true);
      setErrorMsg("");
      try {
        const { data } = await getCustomerFtth(id, currentFilter);
        setData(data.data);
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          setErrorMsg(data.message);
        } else {
          setErrorMsg("Something Error Happened");
        }
      }
      setLoading(false);
    },
    [id]
  );

  useEffect(() => {
    getCustomer(filter);
  }, [id, filter, getCustomer]);

  return {
    data,
    loading,
    errorMsg,
    getCustomer,
  };
}

export function useReportReactivationsHooks({ filter }) {
  const [reactivationData, setReactivationData] = useState([]);
  const [meta, setMeta] = useState({ page: 1, page_size: 10, count: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getReportActivations = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await reportCustomerActivations(filter);
      setReactivationData(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (filter) {
      getReportActivations(filter);
    }
  }, [filter]);

  return {
    reactivationData,
    meta,
    loading,
    errorMsg,
    getReportActivations,
  };
}
